import React, { useEffect, useState, useContext } from "react";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import TooltipConfig from "../../../../Tooltip";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { Table } from "react-bootstrap";

export const TableList = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [totalOnTime, setTotalOnTime] = useState<number[]>([]);
  const [totalDelayed, setTotalDelayed] = useState<number[]>([]);
  const [totalGeneral, setTotalGeneral] = useState<number[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const today= new Date();
    const day = today.getDay();
    const weekday = today.toLocaleString('pt-br', {  weekday: 'long' }).split('-');
    if(day === 0 || day === 6) {
      setCategories([
        'Dia Atual',
        'Média Histórica 4 Semanas',
        `Média Histórica Últimos 4 ${weekday[0]}s`
      ])
    } else {
      setCategories([
        'Dia Atual',
        'Média Histórica 4 Semanas',
        `Média Histórica Últimas 4 ${weekday[0]}s-${weekday[1]}s`
      ])
    }
    
    setTotalOnTime([
      Number(data.total.today_on_time),
      Number(data.total.last_weeks_on_time_avg),
      Number(data.total.last_weekday_on_time_avg),
    ]);
    setTotalDelayed([
      Number(data.total.today_delay),
      Number(data.total.last_weeks_delay_avg),
      Number(data.total.last_weekday_delay_avg)
    ]);
    setTotalGeneral([
      Number(data.total.today_delay) + Number(data.total.today_on_time),
      Number(data.total.last_weeks_delay_avg) + Number(data.total.last_weeks_on_time_avg),
      Number(data.total.last_weekday_delay_avg) + Number(data.total.last_weekday_on_time_avg)
    ]);

    const sizes = getSizesComponent({ id: "table-routes-begin-delays" });
    if (sizes.width < 345) {
      setFontSize({ id: "table-routes-begin-delays", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setCompleteRequisition(true);
  }, [data]);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Tabela - Rotas: Saídas no Horário x Saídas em Atraso`}
        id="table-routes-begin-delays"
      />
      <div
        id={"paddedBox"}
      >
        <div id="chart" style={{ height: heightChart }}>
          <Table
            id="tableRoutesBeginDelays"
            style={{ color: '#fff', textAlign: "center"}}
            bordered
          >
            <thead>
              <tr>
                <th></th>
                <th>No Horário</th>
                <th>Fora do Horário</th>
                <th>Total Geral</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((elem: string, i: number) => {
                return (
                  <tr id={"row_" + i}>
                    <td>{elem}</td>
                    <td>
                      <TooltipConfig
                        content={[`${(totalOnTime[i]/totalGeneral[i] * 100).toFixed(2)}%`]}
                        children={totalOnTime[i]}
                        style={false}
                      />
                    </td>
                    <td>
                      <TooltipConfig
                        content={[`${(totalDelayed[i]/totalGeneral[i] * 100).toFixed(2)}%`]}
                        children={totalDelayed[i]}
                        style={false}
                      />
                    </td>
                    <td>{totalGeneral[i]}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};